import gql from 'graphql-tag'

export const SUBSCRIBE_ORGANIZATION_STOCK_BY_ID = gql`
    subscription ($id: uuid!){
        OrganizationStock: OrganizationStock(where: {organizationId: {_eq: $id}}, order_by: {ProductUnit: {unit: desc}}){
            id
            organizationId
            locationId
            productId
            quantity
            reservedQuantity
            unitId
            totalQuantityInPackets
            created_at
            updated_at
            ProductUnit{
                id
                unit
            }
        }
    }`
